"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedLocationDisplayType = exports.SharingMethod = exports.SHARING_TYPES_WITH_DYNAMIC_DISPLAY_TYPE = exports.SharingType = void 0;
var SharingType;
(function (SharingType) {
    SharingType[SharingType["Created"] = 0] = "Created";
    SharingType[SharingType["Start"] = 1] = "Start";
    SharingType[SharingType["CheckedIn"] = 2] = "CheckedIn";
    SharingType[SharingType["CheckedOut"] = 3] = "CheckedOut";
    SharingType[SharingType["Route"] = 4] = "Route";
    SharingType[SharingType["Late"] = 5] = "Late";
    SharingType[SharingType["Reschedule"] = 6] = "Reschedule";
    SharingType[SharingType["ReadyForPickup"] = 7] = "ReadyForPickup";
    SharingType[SharingType["ScheduleReady"] = 8] = "ScheduleReady";
    SharingType[SharingType["Acknowledged"] = 9] = "Acknowledged";
    SharingType[SharingType["Schedule"] = 10] = "Schedule";
    SharingType[SharingType["OptIn"] = 11] = "OptIn";
    SharingType[SharingType["EtaDelay"] = 12] = "EtaDelay";
    SharingType[SharingType["CustomerPickup"] = 13] = "CustomerPickup";
    SharingType[SharingType["OptInConfirmation"] = 14] = "OptInConfirmation";
    SharingType[SharingType["CustomWorkflow"] = 15] = "CustomWorkflow";
    SharingType[SharingType["NotificationByTemplateId"] = 16] = "NotificationByTemplateId";
})(SharingType || (exports.SharingType = SharingType = {}));
exports.SHARING_TYPES_WITH_DYNAMIC_DISPLAY_TYPE = [
    SharingType.CustomWorkflow,
    SharingType.NotificationByTemplateId
];
var SharingMethod;
(function (SharingMethod) {
    SharingMethod[SharingMethod["Phone"] = 0] = "Phone";
    SharingMethod[SharingMethod["Email"] = 1] = "Email";
    SharingMethod[SharingMethod["Websocket"] = 2] = "Websocket";
    SharingMethod[SharingMethod["None"] = 3] = "None";
    SharingMethod[SharingMethod["Other"] = 4] = "Other";
    SharingMethod[SharingMethod["Api"] = 5] = "Api";
    SharingMethod[SharingMethod["Push"] = 6] = "Push";
    SharingMethod[SharingMethod["Webhook"] = 7] = "Webhook";
})(SharingMethod || (exports.SharingMethod = SharingMethod = {}));
var SharedLocationDisplayType;
(function (SharedLocationDisplayType) {
    SharedLocationDisplayType[SharedLocationDisplayType["Schedule"] = 1] = "Schedule";
    SharedLocationDisplayType[SharedLocationDisplayType["Pickup"] = 2] = "Pickup";
    SharedLocationDisplayType[SharedLocationDisplayType["ScheduleReady"] = 3] = "ScheduleReady";
    SharedLocationDisplayType[SharedLocationDisplayType["Tracking"] = 4] = "Tracking";
    SharedLocationDisplayType[SharedLocationDisplayType["None"] = 5] = "None";
})(SharedLocationDisplayType || (exports.SharedLocationDisplayType = SharedLocationDisplayType = {}));
//# sourceMappingURL=shared_location.js.map